// 消息模块
import $http from '../../utils/http';
let travelPath = 'tio/message';

export const messageList = params => {
    // 消息列表
    return $http({
      url: travelPath + '/queryAll',
      params,
      headers: { 'showLoading': false }
    });
  };

  export const messageReadAll = data => {
    // 消息全部已读
    return $http({
      url: travelPath + '/batchUpdateReadStatus',
      data,
      method: 'POST'
    });
  };

  export const getUnreadQuantity = data => {
    // 消息全部未读小红点
    return $http({
      url: travelPath + '/getUnreadQuantity',
      data,
      method: 'GET'
    });
  };

  export const messageReadOne = data => {
    // 消息全部已读
    return $http({
      url: travelPath + '/updateReadStatus',
      data,
      method: 'POST'
    });
  };

export default {
    messageList,
    messageReadAll,
    messageReadOne,
    getUnreadQuantity
};
